import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=d6be690c&scoped=true&"
import script from "./cookiesPolicy.js?vue&type=script&lang=js&"
export * from "./cookiesPolicy.js?vue&type=script&lang=js&"
import style0 from "./cookiesPolicy.css?vue&type=style&index=0&id=d6be690c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6be690c",
  null
  
)

export default component.exports